import { inject, Injectable } from '@angular/core';
import { WA_LOCAL_STORAGE } from '@ng-web-apis/common';
import { CookiesService } from '@rma/generic/ng/util';
import { Environment } from '@rma/public/generic/util/environment';

@Injectable({
  providedIn: 'root',
})
export class TokenProviderService {
  private readonly cookiesService = inject(CookiesService);
  private readonly environment = inject(Environment);
  private readonly localStorage = inject<Storage>(WA_LOCAL_STORAGE);

  private userTokenKey = '';

  public initialise() {
    this.userTokenKey = `${this.environment.identity.jwtEnvironment}-UserToken`;

    if (!this.hasUserToken()) {
      const cookieToken = this.cookiesService.get('jwt');
      if (cookieToken) {
        this.setUserToken(cookieToken);
      }
    }
  }

  public setUserToken(userToken: string): void {
    this.localStorage?.setItem(this.userTokenKey, userToken);
  }

  public getUserToken(): string | null {
    return this.localStorage?.getItem(this.userTokenKey);
  }

  public hasUserToken(): boolean {
    const token = this.getUserToken();
    return !!token && token !== 'null' && token !== 'undefined';
  }

  public clearUserToken(): void {
    this.localStorage.removeItem(this.userTokenKey);
  }
}
